import * as THREE from 'three'

import Experience from '../Experience'
import CsMap from './CsMap'

/** Owns the scene content. Currently a single GoldSrc map. */
export default class World {
  public readonly map: CsMap

  constructor() {
    Experience.instance.scene.fog = new THREE.Fog(0xd8c8aa, 4200, 14000)
    this.map = new CsMap()
  }

  public update(): void {
    this.map.update()
  }
}
